// extracted by mini-css-extract-plugin
export default {"nav-active":"Year_nav-active__IhQw2","nav-nonactive":"Year_nav-nonactive__jf3JA","button-link":"Year_button-link__dEfFK","logout-button-link":"Year_logout-button-link__QiVPn"};